export default class ContractsHelpers
  constructor: (form_data) ->
    @form_data = form_data

  process_form_data: (attribute) ->
    for i in [0...attribute.length]
      @.form_data.append(attribute[i].name, attribute[i].value)
   
